var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "divBox",
    },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              staticClass: "form-boder-padding",
              attrs: { "label-width": "130px" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _vm._l(_vm.products, function (item, index) {
                return _c(
                  "div",
                  { key: index },
                  [
                    _c("h2", { staticClass: "form_label mb10" }, [
                      _vm._v(_vm._s(item.productName)),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "产品价格：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 0.01,
                            step: 0.01,
                            "controls-position": "right",
                            "step-strictly": "",
                            placeholder: "请输入价格",
                          },
                          model: {
                            value: item.price,
                            callback: function ($$v) {
                              _vm.$set(item, "price", $$v)
                            },
                            expression: "item.price",
                          },
                        }),
                        _vm._v("元 "),
                        _c("div", { staticClass: "from-tips" }, [
                          _vm._v("用户每日参与活动后，所赠送的佣金额度"),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "有效时间：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 1,
                            step: 1,
                            "controls-position": "right",
                            "step-strictly": "",
                            placeholder: "请输入时间",
                          },
                          model: {
                            value: item.validTime,
                            callback: function ($$v) {
                              _vm.$set(item, "validTime", $$v)
                            },
                            expression: "item.validTime",
                          },
                        }),
                        _vm._v("秒 "),
                        _c("div", { staticClass: "from-tips" }, [
                          _vm._v("用户支付后，可聊天的时长"),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "产品文案：", required: "" } },
                      [
                        _c("el-input", {
                          staticClass: "from-ipt-width",
                          attrs: { placeholder: "请输入产品文案描述" },
                          model: {
                            value: item.description,
                            callback: function ($$v) {
                              _vm.$set(
                                item,
                                "description",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "item.description",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["platform:fortune:productConfig:update"],
                          expression:
                            "['platform:fortune:productConfig:update']",
                        },
                      ],
                      attrs: { type: "primary", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formData")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }